import { GiftPdpDispatch } from '@ff-scene-plugins/gift-redux/store';
import { setIsGiftWindowOpen } from './_redux-ui';

export const close = (
    dispatch: GiftPdpDispatch
) => {
    dispatch(setIsGiftWindowOpen(false));
};